import {
  GET_DROP_OR_SWAP,
  GET_DROP_OR_SWAP_DETAIL,
  GET_DROP_OR_SWAP_DETAIL_FAILURE,
  GET_DROP_OR_SWAP_DETAIL_SUCCESS,
  GET_DROP_OR_SWAP_FAILURE,
  GET_DROP_OR_SWAP_SUCCESS,
} from "../constants";

export default class ShiftDropOrSwap {
  static GetDropOrSwap(payload) {
    return {
      type: GET_DROP_OR_SWAP,
      payload,
    };
  }

  static GetDropOrSwapSuccess(payload) {
    return {
      type: GET_DROP_OR_SWAP_SUCCESS,
      payload,
    };
  }

  static GetDropOrSwapFailure(isSubscriptionError) {
    return {
      type: GET_DROP_OR_SWAP_FAILURE,
      payload: isSubscriptionError,
    };
  }

  static GetDropOrSwapDetail(payload, cb) {
    return {
      type: GET_DROP_OR_SWAP_DETAIL,
      payload,
      cb,
    };
  }

  static GetDropOrSwapDetailSuccess(payload) {
    return {
      type: GET_DROP_OR_SWAP_DETAIL_SUCCESS,
      payload,
    };
  }

  static GetDropOrSwapDetailFailure() {
    return {
      type: GET_DROP_OR_SWAP_DETAIL_FAILURE,
    };
  }
}
